import { put, takeEvery, all } from "redux-saga/effects";
import {
  otpValidate,
  logout,
  otpRequest,
  signInWithAuthCredentials,
  refreshAccessToken
} from "../../Services/authentication";
import { throwError } from "../../Services/error";
import { setErrorStatus } from "../status/action";
import { checkAccountAvailability } from "../../Services/api";
import store from "../store";
import { login } from "./actions";
import { updateAccessSyncStatus } from "../../Services/database";

export const authActionTypes = {
  SEND_OTP: "SEND_OTP",
  VERIFY_OTP: "VERIFY_OTP",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  ADD_AUTH_INFO: "ADD_AUTH_INFO",
  REFRESH_ACCESS_TOKEN: "REFRESH_ACCESS_TOKEN",
  CLEAR_CREDENTIAL: "CLEAR_CREDENTIAL"
};

function* loginWorker() {
  try {
    yield setAuthLoading(true);
    const uid = store.getState().auth.data.uid;
    const profile = store.getState().profile.data;
    if (uid !== null && profile !== null) {
      throw throwError("custom", "User already logged in");
    }
    const response = yield signInWithAuthCredentials(
      store.getState().auth.credentials.authCredential
    );
    yield put({
      type: "SET_AUTH_INFO",
      payload: {
        accessToken: response.user.accessToken,
        uid: response.user.uid,
        phoneNumber: response.user.phoneNumber
      }
    });
    yield setAuthLoading(false);
  } catch (error) {
    yield setErrorStatus(error);
    yield setAuthLoading(false);
  }
}

function* logoutWorker(action) {
  try {
    yield setAuthLoading(true);
    yield logout();
    yield put({
      type: "RESET"
    });
    // Raised AFTER RESET so the status reducer's RESET branch can't wipe it.
    if (action?.payload?.status) {
      yield setErrorStatus(action.payload.status);
    }
  } catch (error) {
    yield setAuthLoading(false);
    yield setErrorStatus(error);
    yield setAuthLoading(false);
  }
}

function* sendOtpWorker(action) {
  try {
    yield setAuthLoading(true);
    if (action.payload.type === "login") {
      const response = yield checkAccountAvailability(
        action.payload.phoneNumber
      );
      if (response !== true) {
        throw throwError("custom", "User does not exist. Please signup");
      }
    }
    const verificationId = yield otpRequest(action.payload.phoneNumber);

    yield put({
      type: "SET_AUTH_VERIFICATION_ID",
      payload: {
        verificationId: verificationId
      }
    });

    yield setAuthLoading(false);
  } catch (error) {
    yield setErrorStatus(error);
    yield setAuthLoading(false);
  }
}

function* verifyOtpWorker(action) {
  try {
    yield setAuthLoading(true);
    const authCredential = yield otpValidate(
      action.payload.loginOtp,
      store.getState().auth.credentials.verificationId
    );

    yield put({
      type: "SET_AUTH_CREDENTIALS",
      payload: {
        authCredential: authCredential
      }
    });
    login();
    yield setAuthLoading(false);
  } catch (error) {
    yield setErrorStatus(error);
  }
}

function* clearCredentialWorker() {
  yield put({
    type: "CLEAR_AUTH_CREDENTIALS"
  });
}

function* addAuthInfoWorker(action) {
  try {
    yield put({
      type: "SET_AUTH_INFO",
      payload: {
        accessToken: action.payload.accessToken,
        uid: action.payload.uid,
        phoneNumber: action.payload.phoneNumber
      }
    });
  } catch (error) {
    yield setErrorStatus(error);
  }
}

function* accessTokenRefreshWorker(action) {
  try {
    const accessToken = yield refreshAccessToken();
    const authInfo = store.getState().auth.data;
    const profile = store.getState().profile.data;
    const shouldUpdateAccessStatus = action.payload.shouldUpdateAccessStatus;
    yield put({
      type: "SET_AUTH_TOKEN",
      payload: {
        ...authInfo,
        accessToken
      }
    });

    if (shouldUpdateAccessStatus && profile.employeeId) {
      yield updateAccessSyncStatus(
        profile.employeeId,
        shouldUpdateAccessStatus
      );
    }
  } catch (error) {
    yield setErrorStatus(error);
    console.error("error from accessTokenRefreshWorker : ", error);
  }
}

export default function* authWatcher() {
  yield all([
    takeEvery("SEND_OTP", sendOtpWorker),
    takeEvery("VERIFY_OTP", verifyOtpWorker),
    takeEvery("LOGIN", loginWorker),
    takeEvery("LOGOUT", logoutWorker),
    takeEvery("ADD_AUTH_INFO", addAuthInfoWorker),
    takeEvery("CLEAR_CREDENTIAL", clearCredentialWorker),
    takeEvery("REFRESH_ACCESS_TOKEN", accessTokenRefreshWorker)
  ]);
}

function* setAuthLoading(bool) {
  yield put({
    type: "SET_AUTH_LOADING",
    payload: {
      loading: bool
    }
  });
}
